import { post, postNoAuth } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getChatBotRespond = async (payload) => {
  const builder = new UrlBuilder(`/use-chat-agent`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getChatBotRespondNoAuth = async (payload) => {
  const builder = new UrlBuilder(`/use-chatbot-agent`);
  try {
    const response = await postNoAuth(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
